import { EntityName } from 'record-it-time-common/EntityName';
import { useEntityRepository } from '../../../hooks/entity/useEntityRepository';
import { useConfigureBreadcrumbsWithBuilder } from '../../../hooks/misc/useConfigureBreadcrumbsWithBuilder';

export function useConfigureCreateWorkTimeEntrySelectActivityPageBreadcrumbs(
  parentActivityId: string | undefined
): void {
  const timeTrackingActivityRepository = useEntityRepository(
    EntityName.TimeTrackingActivity
  );

  useConfigureBreadcrumbsWithBuilder((builder) => {
    builder
      .addHomePage()
      .addCreateWorkTimeEntryPage()
      .addCreateWorkTimeEntrySelectActivityPage(null);

    const path = parentActivityId
      ? timeTrackingActivityRepository.getPath(parentActivityId)
      : [];
    for (const activity of path) {
      if (activity) {
        builder.addCreateWorkTimeEntrySelectActivityPage(activity.id);
      }
    }
  });
}
